<template>
  <div>
    <div class="form-section group collapsable">
      <span class="icon"><icon-colored-daypart /></span>
      {{ capitalize($t('names.daypart', { n: 2 })) }}
      <div class="actions">
        <form-section-expand-collapse
          v-if="!canBeRemoved"
          :expanded="isDaypartExpanded"
          @expanded="isDaypartExpanded = true"
          @collapsed="isDaypartExpanded = false" />
        <button
          v-if="canBeRemoved"
          class="btn btn-danger btn-sm"
          @click="clear">
          <icon-delete /> {{ capitalize($t('actions.remove')) }}
        </button>
      </div>
    </div>
    <transition name="fade">
      <div
        v-if="isDaypartExpanded"
        class="form-section-content"
        :class="isDaypartExpanded ? 'form-section-expanded' : 'form-section-collapsed'">
        <div class="form-group row">
          <div
            id="edit_entity_daypart"
            class="col-sm-12">
            <daypart-editor
              :daypart="entity.daypart"
              :is-read-only="isReadOnly"
              @changed="onDaypartChanged" />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script lang="ts" setup>
  import { capitalize, ref } from 'vue';

  import DaypartEditor from '@/common/components/controls/daypartEditor/DaypartEditor.vue';
  import FormSectionExpandCollapse from '@/common/components/controls/FormSectionExpandCollapse.vue';
  import IconColoredDaypart from '@/common/icons/colored/Daypart.vue';
  import IconDelete from '@/common/icons/monochrome/Delete.vue';
  import { LineItem } from '@/common/models';
  import { FullDaypart } from '@/globals';

  interface IProps {
    entity: LineItem;
    canBeRemoved: boolean;
    isReadOnly: boolean;
  }

  withDefaults(defineProps<IProps>(), {
    canBeRemoved: false,
    isReadOnly: false,
  });
  const emits = defineEmits(['changed', 'cleared']);

  const isDaypartExpanded = ref(true);

  function onDaypartChanged(daypart: string): void {
    emits('changed', daypart);
  }

  function clear(): void {
    emits('changed', FullDaypart);
    emits('cleared');
  }
</script>
